import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Tenant } from 'src/app/models/tenant.model';
import { Unit } from 'src/app/models/unit.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-search-tenant',
  template: `
    <ng-template #modalSearchTenant let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Buscar inquilino</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <div class="row">
          <div class="col-12">
            <div class="input-group mb-3">
              <input type="text" class="form-control" [formControl]="search" placeholder="Buscar inquilino" aria-label="Buscar inquilino" aria-describedby="button-addon2">
              <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="searchTenant()">Buscar</button>
            </div>
          </div>
          <div class="col-12">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Correo</th>
                  <th>Teléfono</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let tenant of tenants">
                  <td>{{tenant.name}}</td>
                  <td>{{tenant.email}}</td>
                  <td>{{tenant.phone}}</td>
                  <td>
                    <button class="btn btn-outline-secondary btn-sm" (click)="selectTenant(tenant)">Agregar</button>
                  </td>
                </tr>
              </tbody>
            </table>            
          </div>
        </div>
      </div>
    </ng-template>
  `,
  styles: ``
})
export class ModalSearchTenantComponent {
  @Input() unit: Unit | null = null;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalSearchTenant') modalSearchTenant !: ElementRef;
  tenants: Tenant[] = [];
  search: FormControl = new FormControl();
  private modalRef: NgbModalRef | undefined;
  
  constructor(
    private store: SettlementsService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  searchTenant() {
    this.store.getTenantsQuery({ search: this.search.value }).subscribe((res: any) => {
      this.tenants = res.data;
    })
  }

  selectTenant(tenant: Tenant) {
    this.store.addTenantUnit(tenant.id, this.unit?.id).subscribe({
      next: (res: any) => {
      this.dismiss();
      this.toastr.success('Inquilino agregado correctamente.');
      }, error: (err: any) => {
        this.toastr.error('Error al agregar inquilino.');
      }
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent, { size: 'lg' });
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
